module.exports = __webpack_public_path__ + "img/visitor-img1.0a92963c.png";